type Value = string | number | false | null | undefined;

export const cn = (...values: Value[]): string =>
  values
    .filter((value): value is string => typeof value === 'string' && value.length > 0)
    .join(' ');
